import { useLingui } from '@lingui/react/macro';
import { animated, easings, useInView, useSpring } from '@react-spring/web';
import type { FC } from 'react';
import { cn } from '@/shared/react';
import { useWhyChooseUsList } from './useWhyChooseUsList';

export const WhyChooseUs: FC<{ className?: string }> = ({ className }) => {
  const { t } = useLingui();
  const list = useWhyChooseUsList();
  const [ref, inView] = useInView();

  const img = useSpring({
    filter: `blur(${inView ? 0 : 10}px)`,
    transform: `scale(${inView ? 1 : 2})`,
    opacity: inView ? 1 : 0,
    delay: 150,
    config: { easing: easings.easeInBounce },
  });

  const text = useSpring({
    y: inView ? 0 : 100,
    transform: `scaleY(${inView ? 1 : 1.5})`,
    opacity: inView ? 1 : 0,
    delay: 250,
    config: { easing: easings.easeInBounce },
  });

  return (
    <section id="why-choose-us" className={cn('relative', className)}>
      <div className="px-3 mx-auto max-w-desktop text-center">
        <h2 className="text-2xl desktop:text-4xl leading-none mb-3">{t`Why thousands choose IQX`}</h2>
        <p className="text-base text-content-secondary mb-10">
          {t`More than just a trading platform, IQX is built for how Iraq actually uses crypto.`}
        </p>

        <div
          className="flex gap-8 items-stretch justify-between flex-wrap max-w-full w-max mx-auto"
          ref={ref}
        >
          {list.map((item) => (
            <div
              key={item.key}
              className="bg-background-brand/5 p-1 rounded-5xl w-full min-w-full desktop:min-w-[450px] max-w-[450px] overflow-hidden"
            >
              <animated.img
                src={item.background}
                alt={item.key}
                width="100%"
                className="w-full h-auto"
                style={img}
              />
              <animated.h3
                style={text}
                className="text-lg desktop:text-xl text-start pt-4 pb-2 px-widget font-medium"
              >
                {item.title}
              </animated.h3>
              <animated.p
                style={text}
                className="text-base desktop:text-lg px-widget pb-5 text-start"
              >
                {item.description}
              </animated.p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
